import AccountPage from '../../components/pages/Account';

const Account: React.FC = () => {
  return <AccountPage />;
};

export default Account;
